<style scoped lang="scss" type="text/scss">
    .embed-functional-bar-container {
        position: absolute;
        top: 0;
        right: 0;
        transition: all .2s;
        width: 100%;
        height: 0;
        overflow: hidden;
        background-color: rgba(0, 0, 0, .8);
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 1rem;

        .left, .right {
            display: flex;
            align-items: center;
        }

        .functional-button {
            color: #CCC;
            font-size: .75rem;
            margin-right: .5rem;

            &:last-of-type {
                margin-right: 0;
            }

            .icon {
                font-size: .75rem;
            }

            &:hover {
                cursor: pointer;

                &.delete {
                    color: #FF3333;
                }

                &.edit, &.download {
                    color: #3E9EFF;
                }
            }
        }
    }
</style>

<template>
    <div class="embed-functional-bar-container">
        <div class="left">
            <span class="functional-button download" v-if="downloadable" @click.stop="callDownload">
            <i class="icon">&#xe6b0;</i>
            <span class="text">下载</span>
            </span>

            <span class="functional-button edit" v-if="editable" @click.stop="callEdit">
            <i class="icon">&#xe65c;</i>
            <span class="text">编辑</span>
            </span>
        </div>
        <div class="right">
            <span class="functional-button delete" v-if="removable" @click.stop="callRemove">
            <i class="icon">&#xe61e;</i>
            <span class="text">删除</span>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: '',
        props: {
            downloadable: {
                type: Boolean,
                default: true
            },
            editable: {
                type: Boolean,
                default: true
            },
            removable: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {};
        },
        methods: {
            callDownload () {
                this.$emit('call-download');
            },
            callEdit () {
                this.$emit('call-edit');
            },
            callRemove () {
                this.$emit('call-remove');
            }
        }
    };
</script>
